import { render, staticRenderFns } from "./ItemProche.vue?vue&type=template&id=fbeb793e&scoped=true&"
import script from "./ItemProche.vue?vue&type=script&lang=js&"
export * from "./ItemProche.vue?vue&type=script&lang=js&"
import style0 from "./ItemProche.vue?vue&type=style&index=0&id=fbeb793e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeb793e",
  null
  
)

export default component.exports